/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { FC, ReactNode, useEffect, useState } from "react"
import dayjs from "dayjs"
import { Row, Col } from "@duxton-web/ui"
import { phonePreviewStyle } from "./previewStyles"

interface IProps {
  children: ReactNode
}

export const PreviewPhone: FC<IProps> = ({ children }: IProps) => {
  const [time, setTime] = useState("00:00")
  const [battery, setBattery] = useState(100)

  useEffect(() => {
    setTime(dayjs().format("HH:mm"))
    // @ts-ignore
    window?.navigator
      // @ts-ignore
      ?.getBattery?.()
      .then((batteryManager: any) => setBattery(batteryManager.level * 100))
  }, [])
  return (
    <div
      css={css`
        ${phonePreviewStyle}
        width: 373px;
      `}
    >
      <div className="black-frame">
        <div className="phone-sensor">
          <div className="long-white" />
          <div className="circle-white-1" />
          <div className="circle-white-2" />
        </div>
        <div
          css={css`
            padding: 0 23px;
          `}
        >
          <div className="preview-screen">
            <div className="overlay">
              <Row>
                <Col span={12}>{time}</Col>
                <Col
                  span={12}
                  css={css`
                    text-align: right;
                  `}
                >
                  <img src={require("./icons/wifi.svg")} />
                  <img src={require("./icons/cellular.svg")} />
                  <img src={require("./icons/battery.svg")} />
                  {battery}%
                </Col>
              </Row>
            </div>
            <div
              css={css`
                overflow-y: scroll;
                overflow-x: hidden;
                height: 100%;
              `}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
